import { HeadCell } from "../../../components/common/table/CustomTable";

export const getHeadersBl = (isAdminUser: boolean): HeadCell[] => {
  return [
    { disablePadding: false, id: "number", label: "#", numeric: true },
    {
      disablePadding: false,
      id: "id",
      label: "ID",
      numeric: true,
      hidden: true,
    },
    { disablePadding: false, id: "booking", label: "BOOKING", numeric: false },
    {
      disablePadding: false,
      id: "dae",
      label: "DAE",
      numeric: false,
      width: "200px",
    },
    {
      disablePadding: false,
      id: "enter_date",
      label: "FECHA DE INGRESO",
      numeric: false,
      hidden: !isAdminUser,
    },
    {
      disablePadding: false,
      id: "download_bl_copy",
      label: "DESCARGAR BL COPIA",
      numeric: false,
    },
    {
      disablePadding: false,
      id: "download_bl_original",
      label: "DESCARGAR BL ORIGINAL",
      numeric: false,
    },
    {
      disablePadding: false,
      id: "download_carta",
      label: "DESCARGAR CARTA",
      numeric: false,
    },
    {
      disablePadding: false,
      id: "clonar",
      label: "CLONAR",
      numeric: false,
    },
    {
      disablePadding: false,
      id: "delete",
      label: "DESACTIVAR",
      numeric: false,
    },

    {
      disablePadding: false,
      id: "creado_api",
      label: "CREADO API",
      numeric: false,
      hidden: !isAdminUser,
    },
    {
      disablePadding: false,
      id: "fecha_descarga_copy",
      label: "fecha descarga copia",
      numeric: false,
      hidden: !isAdminUser,
    },
    {
      disablePadding: false,
      id: "fecha_descarga_original",
      label: "fecha descarga original",
      numeric: false,
      hidden: !isAdminUser,
    },
    {
      disablePadding: false,
      id: "subir_documento",
      label: "subir documento",
      numeric: false,
      hidden: !isAdminUser,
    },
    {
      disablePadding: false,
      id: "edit_bl",
      label: "Editar",
      numeric: false,
      hidden: !isAdminUser,
    },
    {
      disablePadding: false,
      id: "history",
      label: "Ver Historial",
      numeric: false,
      hidden: !isAdminUser,
    },
    {
      disablePadding: false,
      id: "delete_admin",
      label: "ELIMINAR (ADMIN)",
      numeric: false,
      hidden: !isAdminUser,
    },
  ];
};
